import React from "react";
import { XMarkIcon } from "@heroicons/react/24/outline";
import globalStyle from "../../styles/globalStyle";

interface AlertProps {
  type: "success" | "error" | "warning" | "info";
  message: string;
  onClose?: () => void;
  className?: string;
}

const Alert: React.FC<AlertProps> = ({
  type,
  message,
  onClose,
  className = "",
}) => {
  const typeClasses = {
    success: globalStyle.alertSuccess,
    error: globalStyle.alertError,
    warning: globalStyle.alertWarning,
    info: globalStyle.alertInfo,
  }[type];

  return (
    <div
      className={`${globalStyle.alert} ${typeClasses} ${className} flex items-start justify-between`}
    >
      <div className="flex-1">
        <p className={globalStyle.body2}>{message}</p>
      </div>
      {onClose && (
        <button
          onClick={onClose}
          className="ml-4 flex-shrink-0 hover:text-white transition-colors"
        >
          <XMarkIcon className="w-4 h-4" />
        </button>
      )}
    </div>
  );
};

export default Alert;
